import * as React from 'react';
import { createViewConfig, media } from '@sail/engine';
import { Section } from '../Section/Section';
import { RowLayout } from '../RowLayout/RowLayout';
import { css, tokens } from '@sail/ui';
import { stripeStretch } from '../../lib/utils';
export const HeroSectionConfig = createViewConfig({
    props: {},
    name: 'HeroSection',
    defaults: {
        contentAngledMarginBottom: 'normal'
    }
});
/**
 * HeroSection
 *
 * A layout component that combines features from ProductHeroSection and HeroSection from mkt.
 *
 * - Manages nav and content layout
 * - Handles angle at the hero level
 * - Allows custom margin/padding at the bottom
 */ export const HeroSection = HeroSectionConfig.createView((props)=>{
    const { children, nav, subviews, contentAngledMarginBottom, ...rest } = props;
    const hasNav = Boolean(nav);
    return /*#__PURE__*/ React.createElement(Section, {
        paddingTop: "none",
        ...rest
    }, /*#__PURE__*/ React.createElement(RowLayout, {
        inherits: subviews.heroLayout,
        css: !hasNav ? {
            marginTop: '36px',
            [media.up(tokens.viewport.xlarge)]: {
                marginTop: '84px'
            }
        } : undefined
    }, nav, /*#__PURE__*/ React.createElement(RowLayout, {
        inherits: subviews.heroContent
    }, children)));
}, {
    css: {
        position: 'relative',
        zIndex: 2
    },
    variants: {
        angle: {
            bottom: {
                subviews: {
                    heroContent: css({
                        marginBottom: `${stripeStretch(192, 80)}`,
                        [media.up(tokens.viewport.xlarge)]: {
                            marginBottom: '80px'
                        }
                    })
                }
            }
        },
        contentAngledMarginBottom: {
            none: {
                subviews: {
                    heroContent: css({
                        marginBottom: 0
                    })
                }
            }
        }
    },
    forward: {
        angle: true,
        contentAngledMarginBottom: true
    }
});

//# sourceMappingURL=HeroSection.js.map